var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsgRequestWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 1.9999C0.599609 1.11625 1.31595 0.399902 2.19961 0.399902H7.79961C8.68326 0.399902 9.39961 1.11625 9.39961 1.9999V5.1999C9.39961 6.08356 8.68326 6.7999 7.79961 6.7999H6.19961L3.79961 9.1999V6.7999H2.19961C1.31595 6.7999 0.599609 6.08356 0.599609 5.1999V1.9999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9996 3.5999V4.3999C10.9996 6.60904 9.20875 8.3999 6.99961 8.3999H6.86235L5.44899 9.81326C5.67284 9.93239 5.92834 9.9999 6.19961 9.9999H7.79961L10.1996 12.3999V9.9999H11.7996C12.6833 9.9999 13.3996 9.28356 13.3996 8.3999V5.1999C13.3996 4.31625 12.6833 3.5999 11.7996 3.5999H10.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsgRequestWhite);
export default __webpack_public_path__ + "static/media/msg-request-white.bc489cf889a981b12ae076d93168e015.svg";
export { ForwardRef as ReactComponent };